
import { defineComponent, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { LoadingBtnService } from '@/views/dashboard/manage/port-manage/_components/loading-btn/loading-btn.service'
export default defineComponent({
  props: {
    fileDispatch: {
      type: Boolean,
      default: false
    },
    deviceId: {
      type: String,
    },
  },
  emits: ['getOriginData'],
  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([LoadingBtnService])
    const service = injector.get(LoadingBtnService)
    const data = reactive({
      btnLoading: false
    })
    return {
      t,
      ...toRefs(data),
      scanPort () {
        if (data.btnLoading) {
          return
        }
        data.btnLoading = true
        if (props.fileDispatch) {
          setTimeout(() => {
            data.btnLoading = false
            context.emit('getOriginData')
            // eslint-disable-next-line no-magic-numbers
          }, 3000)
        } else {
          service.portScan([props.deviceId]).then(() => {
            setTimeout(() => {
              data.btnLoading = false
              context.emit('getOriginData')
              // eslint-disable-next-line no-magic-numbers
            }, 3000)
          })
        }
      },
    }
  }
})
